
import AddDistributorDataDialog from '@/components/AddDistributorDataDialog.vue'
import HashColor from '@/plugins/hashcolor'
import { useStore } from '@/store'
import { Distributor } from '@/types/Distributor'
import Role from '@/types/Role'
import BillingSettings from '@/views/BillingSettings.vue'
import Vue from 'vue'

export default Vue.extend({
  name: 'App',
  components: {
    AddDistributorDataDialog,
    BillingSettings,
  },
  data: () => ({
    tab: null,
    search: null,
    user: null,
    selectedRole: null,
    selectedEmail: null,
    showDistributorDataDialog: false,
    selectedDistributor: null as Distributor | null,
  }),
  computed: {
    distributorHeaders(): { text: string; value: string; width?: string }[] {
      return [
        {
          text: 'Country',
          value: 'country',
          width: '20%',
        },
        {
          text: 'Price',
          value: 'price',
          width: '10%',
        },
        {
          text: 'Currency',
          value: 'currency',
          width: '10%',
        },
        {
          text: 'Emails',
          value: 'emails',
          width: '50%',
        },
        {
          text: 'Actions',
          value: 'actions',
          width: '10%',
        },
      ]
    },
    roles() {
      return this.$store.getters.roles
    },
    currentRole() {
      if (this.selectedRole)
        return this.$store.getters.roles.find((role: Role) => role?.id === this.selectedRole)
      else return new Array<Role>()
    },
    loading() {
      return this.$store.getters.loading
    },
    distributors(): Distributor[] {
      return useStore().distributorsModule.distributors
    },
    distributorItems(): Distributor[] {
      return this.distributors.map((distributor) => {
        return {
          id: distributor.id,
          country: { name: distributor.country.name, alpha3Code: distributor.country.alpha3Code },
          price: distributor.price,
          currency: distributor.currency,
          emails: distributor.emails,
        }
      })
    },
  },

  methods: {
    handleDistributorEditorClick(distributor: Distributor) {
      this.selectedDistributor = distributor
      this.showDistributorDataDialog = true
    },
    async handleDistributorDeleteClick(distributor: Distributor) {
      await this.$store.dispatch('distributorsModule/removeDistributor', distributor.id)
    },
    async addToRole() {
      await this.$store.dispatch('addToRole', {
        userEmail: this.selectedEmail,
        roleId: this.selectedRole,
      })
    },
    async removeFromRole(user: { id: string; name: string; email: string }) {
      if (confirm(`Are you sure you want to remove ${user.name} from ${this.selectedRole} role?`))
        await this.$store.dispatch('removeFromRole', {
          userId: user.id,
          roleId: this.selectedRole,
        })
    },
    getColor(what: string) {
      return HashColor.get(what ? what : '?')
    },
    nameInitials(name: string) {
      if (!name) return '?'
      const array = name.split(' ')
      let initials = ''

      array.forEach((element: string) => (initials += element.charAt(0)))

      if (initials.length === 0) {
        return '?'
      } else {
        return initials
      }
    },
  },
  async created() {
    await this.$store.dispatch('fetchRoles')
    await this.$store.dispatch('distributorsModule/subscribeToDistributors')
    await this.$store.dispatch('billingExceptionModule/subscribeToBillingException')
    await this.$store.dispatch('billingMultipliersModule/subscribeToBillingMultipliers')
  },
  watch: {
    showDistributorDataDialog(newValue: boolean) {
      if (!newValue) this.selectedDistributor = null
    },
  },
})
